<template>
    <div class="module"
         style="position: relative;">
        <helpinfo :helpData="helpData" />
        <envSelect @envId="envClick"></envSelect>
        <div class="module-container"
             style="padding:15px; margin-top:-17px;">
            <input ref="copyrelay"
                   v-model="copyId"
                   class="copy-el" />
            <rc-table ref="rcTable"
                      :tableAttr="tableAttr">
                <Button slot="tootipL"
                        @click="refresh">
                    <i class="icon-refresh-o-2"></i>
                </Button>
                <Button slot="tootipL"
                        type="primary"
                        :disabled="!(canCreate && hasPermission('CB090503'))"
                        @click="createAcl">
                    <i class="icon-plus-o-1"></i><span>{{$t('创建')}}</span>
                </Button>
            </rc-table>
        </div>
        <createAcl @refresh="refresh"
                   ref="createAcl" />
        <relatedsubnet ref="relatedsubnet"
                       type="acl"
                       @refresh="refresh" />
    </div>
</template>
<script>
import envSelect from '@c/basic/env'
import API from '@/service/api.js'
import helpinfo from '@c/basic/helpinfo'
import rcTable from '@c/basic/rcTable'
import createAcl from './components/createacl.vue'
import relatedsubnet from './components/related.vue'
import dropdownlist from '@c/basic/dropdownlist'
export default {
    name: 'networkacl',
    components: {
        rcTable,
        helpinfo,
        createAcl,
        relatedsubnet,
        envSelect
    },
    data: function () {
        return {
            copyId: null,
            helpData: {
                type: '',
                modelName: this.$t('网络ACL')
            },
            currentFloatIp: {},
            canCreateEnv: ['Qcloud', 'Aliyun', 'OpenStack', 'Nine9Cloud', 'ESCloud', 'CloudOS', 'HuaweiCloud', 'Aws', 'HCSO', 'ApsaraStack'], // 可以创建弹性IP的云环境
            canCreate: true, // 是否有创建按钮can
            canDelete: true,
            selected: [],
            columns: [
                {
                    title: this.$t('名称') + '/ID',
                    key: 'id',
                    sortable: false,
                    columnShow: true,
                    columnsChoosed: true,
                    disabledSearch: true,
                    className: 'ellipsis',
                    resizable: true,
                    width: 200,
                    render: (h, params) => {
                        return h('div', {
                            class: 'ellipsis  resource',
                            style: { position: 'relative' }
                        }, [
                            h(
                                'div',
                                [
                                    h(
                                        'div',
                                        [
                                            h('a', {
                                                class: 'ellipsis name',
                                                attrs: {
                                                    title: params.row.name
                                                },
                                                on: {
                                                    click: () => {
                                                        this.viewDetails(params.row)
                                                    }
                                                }
                                            }, params.row.name)
                                        ]
                                    )]
                            ),
                            h(
                                'div',
                                {
                                    class: 'ellipsis',
                                    style: { width: '170px', color: '#666', paddingBottom: '5px' },
                                    attrs: {
                                        title: params.row.uuid
                                    }
                                },
                                params.row.uuid
                            ),
                            h(
                                'Tooltip',
                                {
                                    class: 'rc-tips copyId',
                                    style: { position: 'absolute', left: '175px', top: '20px', width: '15px' },
                                    props: {
                                        transfer: true,
                                        placement: 'top',
                                        theme: 'light',
                                        content: this.$t('复制ID')
                                    }
                                },
                                [
                                    h('Icon', {
                                        class: 'copy-icon',
                                        style: { color: '#1f68b3', 'font-size': '14px' },
                                        props: {
                                            type: 'ios-browsers-outline'
                                        },
                                        on: {
                                            click: () =>
                                                this.copylink(
                                                    params.row.uuid
                                                )
                                        }
                                    })
                                ]
                            )
                        ]
                        )
                    }
                },
                {
                    title: this.$t('云环境'),
                    key: 'cloudEnvType',
                    sortable: true,
                    columnShow: true,
                    disabledSearch: true,
                    columnsChoosed: true,
                    className: 'ellipsis',
                    resizable: true,
                    width: 170,
                    render: (h, params) => {
                        return h('p', { attrs: { title: params.row.cloudEnvName }, class: { 'rc-ellipsis': true } }, [
                            h('i', { class: this.envIcon(params.row.cloudEnvType), style: 'margin-right: 0;' }),
                            h('span', { class: 'icon-text' }, !params.row.cloudEnvName ? this.$t('其他') : params.row.cloudEnvName)
                        ])
                    }
                },
                {
                    title: this.$t('状态'),
                    key: 'adminStateUp',
                    sortable: true,
                    className: 'ellipsis',
                    columnShow: true,
                    disabledSearch: true,
                    columnsChoosed: true,
                    resizable: true,
                    width: 100,
                    render: (h, params) => {
                        return h('statusview', {
                            props: {
                                state: Boolean(params.row.adminStateUp),
                                stateName: params.row.adminStateUp === 'true' ? this.$t('开启') : this.$t('关闭')
                            }
                        })
                    }
                },
                // {
                //     title: this.$t('状态'),
                //     key: 'status',
                //     sortable: true,
                //     className: 'ellipsis',
                //     columnShow: true,
                //     disabledSearch: true,
                //     columnsChoosed: true,
                //     resizable: true,
                //     width: 100,
                //     render: (h, params) => {
                //         const statusName = {
                //             ACTIVE: '活跃',
                //             INACTIVE: '非活跃',
                //             ERROR: '错误'
                //         }
                //         return h('statusview', {
                //             props: {
                //                 state: params.row.status.toLowerCase(),
                //                 stateName: statusName[params.row.status]
                //             }
                //         })
                //     }
                // },
                {
                    title: this.$t('关联子网'),
                    key: 'bindSubnetInfo',
                    className: 'ellipsis',
                    columnShow: true,
                    disabledSearch: true,
                    columnsChoosed: true,
                    resizable: true,
                    width: 120,
                    render: (h, params) => h('span', { attrs: { title: params.row.bindSubnetInfo } }, params.row.bindSubnetInfo)
                },
                {
                    title: this.$t('描述'),
                    key: 'description',
                    className: 'ellipsis',
                    columnShow: true,
                    disabledSearch: true,
                    columnsChoosed: true,
                    resizable: true,
                    width: 120,
                    render: (h, params) => h('span', { attrs: { title: params.row.description } }, params.row.description)
                },
                {
                    title: this.$t('所属项目'),
                    key: 'orgName',
                    sortable: true,
                    columnShow: true,
                    columnsChoosed: true,
                    disabledSearch: true,
                    className: 'ellipsis',
                    resizable: true,
                    minWidth: 120,
                    render: (h, params) => h('span', { attrs: { title: params.row.orgName } }, params.row.orgName)
                },
                {
                    title: this.$t('操作'),
                    key: 'operate',
                    width: 200,
                    className: 'ellipsis',
                    fixed: 'right',
                    // supportEnvs: ['ESCloud', 'OpenStack', 'Nine9Cloud', 'CloudOS', 'HuaweiCloud', 'HCSO', 'Aliyun', 'Qcloud', 'Aws', 'ApsaraStack'],
                    render: (h, params) => {
                        const arr = []
                        arr.push(h(dropdownlist, {
                            props: {
                                operateConfig: this.configBtn(params.row)
                            },
                            style: 'cursor:pointer;display:inline-block;margin-left: 5px;',
                            on: { event: (type) => { this.operate(type, params.row) } }
                        }))

                        return h('div', { class: 'tbl-btn-div' }, [
                            h('a', {
                                class: { disabled: !((params.row.status === 'ACTIVE' || params.row.adminStateUp === 'true') && this.hasPermission('CB090504')) },
                                on: { click: () => ((params.row.status === 'ACTIVE' || params.row.adminStateUp === 'true') && this.hasPermission('CB090504')) && this.relatedSubnet(params.row) }
                            }, this.$t('关联子网')),
                            h('a', {
                                class: { disabled: !this.hasPermission('CB0905') },
                                on: { click: () => this.hasPermission('CB0905') && this.setrulesFun(params.row) }
                            }, this.$t('配置规则')),
                            h('div', {
                                style: { display: 'inline-block' },
                                class: 'tbl-operate'
                            }, arr)
                        ])
                    }

                }
            ],
            tableAttr: {
                source: {
                    type: 'get',
                    url: this.urlFormat(API.FIREWALL, false),
                    params: {
                        projectId: this.$store.state.user.currentUser.projectId === 'all' ? '' : this.$store.state.user.currentUser.projectId,
                        cloudEnvId: sessionStorage.getItem('resourcesEnvId') || null
                    }
                },
                isWebsoct: true,
                wsKey: 'id',
                searchColumns: [
                    {
                        key: 'fireWallNameLike',
                        title: this.$t('名称'),
                        searchDefaultValue: ''
                    }
                ],
                referenceVal: 1856,
                pageData: {
                    pageWays: 'client'
                },
                searchShow: true,
                tableSearchKey: '', // 当作查询保持的key存在
                searchDefaultValueList: [], // 默认初始化搜索标签加入
                tableColKey: '',
                isMultiSelect: false,
                columnsChooseShow: true,
                columns: []
            },
            modalAdd: false,
            modalBinding: false,
            instanceType: {
                'RES-HOST': this.$t('云主机'),
                'RES-ROUTER': this.$t('路由器'),
                'RES-SLB': this.$t('负载均衡')
            },
            instanceWs: null
        }
    },
    created () {
        this.init()
    },
    mounted () {
        this.websoctRefesh()
    },
    beforeDestroy () {
        // 取消websocket订阅
        if (this.instanceWs) {
            this.instanceWs.unsubscribe()
            this.$store.commit('deleteWsList', '/topic/floating_ip')
        }
    },
    methods: {
        // 云环境查询
        envClick (data) {
            this.tableAttr.source.params.cloudEnvId = data
            this.$refs.rcTable && this.refresh()
        },
        // 复制剪切板
        copylink (id) {
            this.copyId = id
            this.$nextTick(() => {
                const copyrelay = this.$refs.copyrelay
                copyrelay.select()
                document.execCommand('Copy')
                this.$Message.success(this.$t('ID复制成功'))
            })
        },
        fetchDate () {
            this.init()
        },
        init () {
            this.configurationTable()
        },
        viewDetails (obj) {
            this.$router.push({
                path: `/mgt/network_acl/detail/${obj.id}`,
                query: {
                    envType: obj.cloudEnvType,
                    envName: obj.cloudEnvName,
                    envId: obj.cloudEnvId,
                    name: obj.name
                }
            })
        },
        // 生成更多按钮
        configBtn: function (obj) {
            const btnConfig = []
            const resizeDisabled = this.hasPermission('CB0905')
            if (resizeDisabled && obj.adminStateUp === 'true') {
                btnConfig.push({ value: 'closeAcl', btnName: this.$t('关闭'), display: true, disabled: !this.hasPermission('CB090501') })
            }
            if (resizeDisabled && obj.adminStateUp !== 'true') {
                btnConfig.push({ value: 'openAcl', btnName: this.$t('开启'), display: true, disabled: !this.hasPermission('CB090501') })
            }
            if (this.hasPermission('CB0905')) {
                btnConfig.push({ value: 'editAcl', btnName: this.$t('编辑'), display: true, disabled: !this.hasPermission('CB090501') })
            }
            if (this.hasPermission('CB0905')) {
                btnConfig.push({ value: 'deleteFun', btnName: this.$t('删除'), display: true, disabled: !this.hasPermission('CB090502') })
            }

            return JSON.stringify(btnConfig)
        },
        // 更多按钮事件分发
        operate: function (operateType, row) {
            switch (operateType) {
                case 'openAcl':
                    if (!this.hasPermission('CB090501')) return
                    this.closeAcl(row)
                    break
                case 'closeAcl':
                    if (!this.hasPermission('CB090501')) return
                    this.closeAcl(row)
                    break
                case 'deleteFun':
                    if (!this.hasPermission('CB090502')) return
                    this.deleteFun(row)
                    break
                case 'editAcl':
                    if (!this.hasPermission('CB090501')) return
                    this.editAcl(row)
                    break
            }
        },
        configurationTable () { // 重新配置表格参数
            this.tableAttr.source.params.envId = this.envId
            this.tableAttr.columns = this.columns.filter(col => {
                let res = false
                if (!col.excludeEnvs && !col.supportEnvs) {
                    res = true
                } else if (col.supportEnvs && col.supportEnvs.includes(this.envType)) {
                    res = true
                } else if (col.excludeEnvs && !col.excludeEnvs.includes(this.envType)) {
                    res = true
                }
                return res
            })
            this.$refs.rcTable && this.$refs.rcTable.init()
        },
        refresh () {
            this.tableAttr.source.params.expireDay = null
            if (this.$refs.rcTable && this.$refs.rcTable.refreshTable) {
                this.$refs.rcTable.refreshTable()
            }
            this.selected = []
        },
        createAcl () { // 点击创建
            // if (!this.hasPermission('MD1002')) return
            this.$refs.createAcl.openModal()
        },
        editAcl (row) { // 编辑
            // if (!this.hasPermission('MD1002')) return
            this.$refs.createAcl.openModal(row)
        },
        closeAcl (obj) {
            const params = {
                id: obj.id,
                cloudEnvId: obj.cloudEnvId,
                adminStateUp: false
            }
            //  if (!this.hasPermission('MD1006')) return
            let message = `确定要关闭网络ACL${obj.name}吗？<div style="margin-top:8px">关闭网络ACL后，自定义的ACL规则会失效，但系统自带的默认规则仍然生效，即网络ACL会拒绝所有出入子网的流量。</div>`
            if (obj.adminStateUp !== 'true') {
                message = `确定启用该网络ACL${obj.name}吗？`
                params.adminStateUp = true
            }
            this.$Modal.confirm({
                title: obj.adminStateUp !== 'true' ? this.$t('启用') : this.$t('关闭'),
                content: message,
                onOk: () => {
                    this.axios.put(this.urlFormat(API.FIREWALL, false), params).then(res => {
                        this.refresh()
                    })
                }
            })
        },
        deleteFun (obj) {
            this.$Modal.confirm({
                title: this.$t('删除'),
                content: `确定要删除网络ACL${obj.name}吗？`,
                onOk: () => {
                    this.axios.delete(this.urlFormat(API.FIREWALL, false) + '/' + obj.id).then(res => {
                        this.refresh()
                    })
                }
            })
        },
        // 点击配置规则
        setrulesFun (obj) {
            this.$router.push({
                path: `/mgt/network_acl/detail/${obj.id}`,
                query: {
                    envType: obj.cloudEnvType,
                    envName: obj.cloudEnvName,
                    envId: obj.cloudEnvId,
                    name: obj.name,
                    tabName: 'inDirection'
                }
            })
        },
        relatedSubnet (row) {
            this.$refs.relatedsubnet.openModal(row)
        },
        websoctRefesh () {
            const refresh = this.$refs.rcTable.refreshTable
            this.instanceWs = this.$websocket('/topic/floating_ip', (result) => {
                refresh(null, null, result.body ? parseInt(result.body) : '')
            })
            // 存储websocket
            this.$store.commit('addWsList', {
                url: '/topic/floating_ip',
                callback: (result) => {
                    refresh(null, null, result.body ? parseInt(result.body) : '')
                }
            })
        }
    },
    watch: {
        // 如果路由有变化，会执行该方法
        $route: 'fetchDate'
    }
}
</script>
<style lang="less" scoped>
.floatip-add {
    .form-item {
        width: 300px;
    }
    .float-bandwidth {
        position: absolute;
        top: -14px;
        right: 43px;
    }
}
.copy-el {
    opacity: 0;
    height: 1px;
    overflow: hidden;
    margin: 0;
    padding: 0;
}
</style>
<style lang="less">
.newRcTable .rcTable-content .ellipsis > div.copyId {
    opacity: 0;
}
.newRcTable .rcTable-content .ellipsis > div {
    .copyId {
        opacity: 0;
    }
}
.newRcTable .rcTable-content .ellipsis > div:hover {
    .copyId {
        opacity: 1;
    }
}
.newRcTable .rcTable-content .ellipsis > div {
    .name {
        line-height: 22px;
    }
    .copyId {
        line-height: 22px;
    }
}
</style>
